import React from 'react';
import { Icon } from './Icon';

const InteractionsIcon = ({ size }: Props) => {
  return (
    <Icon type="box" color="bg-label-success" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { InteractionsIcon };